import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['workspace', 'view', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_EMBED_ZOHO_URL_',
  }
);

export interface FetchEmbedZohoState {
  data: {
    data: {
      embedUrl: '';
    };
  };
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchEmbedZohoRequestAction {
  workspace: string;
  view: string;

  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: {
    data: {
      embedUrl: '';
    };
  };
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchEmbedZohoState = {
  data: {
    data: {
      embedUrl: '',
    },
  },
  loading: false,
  errorMessage: null,
};

const request = (state: FetchEmbedZohoState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchEmbedZohoState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchEmbedZohoState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchEmbedZohoState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchEmbedZohoUrl = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchEmbedZohoTypes = Types;
export const FetchEmbedZohoActions = Creators;
